export enum StepOfLogin {
  LOGIN = 'login',
  RESET_PASSWORD = 'reset-password',
  SUCCESS_RESET = 'success-reset',
}
